import "core-js/modules/es.array.reduce.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import _isArray from 'lodash/isArray';
import _sortBy from 'lodash/sortBy';
import _values from 'lodash/values';
import transformLinks from './transform';

function getIndividualLinks(links) {
  return links.filter(function (_ref) {
    var groupName = _ref.groupName;
    return !groupName;
  });
}

function createLinkGroups(links) {
  return links.reduce(function (linkGroups, link) {
    var groupName = link.groupName;

    if (groupName) {
      return _objectSpread(_objectSpread({}, linkGroups), {}, _defineProperty({}, groupName, linkGroups[groupName] ? [].concat(_toConsumableArray(linkGroups[groupName]), [link]) : [link]));
    }

    return linkGroups;
  }, {});
}

function mergeLinks(individualLinks, groupedLinks) {
  return [].concat(_toConsumableArray(individualLinks), _toConsumableArray(_values(groupedLinks))).map(function (linkOrGroup) {
    if (_isArray(linkOrGroup)) {
      var firstGroupItem = linkOrGroup[0];
      var groupName = firstGroupItem.groupName,
          navigationPriority = firstGroupItem.navigationPriority;
      return {
        navigationPriority: navigationPriority,
        title: groupName,
        links: linkOrGroup
      };
    }

    return linkOrGroup;
  });
}

function sortLinks(links) {
  return _sortBy(links, ['navigationPriority']);
}

export function groupLinks(links) {
  var transformedLinks = transformLinks(links);
  var individualLinks = getIndividualLinks(transformedLinks);
  var linkGroups = createLinkGroups(transformedLinks);
  var mergedLinks = mergeLinks(individualLinks, linkGroups);
  return sortLinks(mergedLinks);
}